import React, { useContext } from 'react'
import { Link } from 'gatsby'
import Container from 'react-bootstrap/Container'
import Navbar from 'react-bootstrap/Navbar'
import Stack from 'react-bootstrap/Stack'
import Bag from './bag'
import Cart from './cart'
import Nav from './nav'
import NavSearch from '../algolia/nav-search'
import AppContext from '../context/app'

export default function Naviagtion({ style }) {
    const { setShowNav } = useContext(AppContext)

    return (
        <Navbar sticky='top' expand={false} className='p-0' style={style}>
            <Container fluid style={{ background: 'black', zIndex: 2 }} className='position-relative'>
                <Container className='d-flex align-items-center justify-content-between' style={{ paddingTop: 9, paddingBottom: 9 }}>
                    {/* AKAI LOGO */}
                    <Stack direction='horizontal' className='align-items-center' gap={4}>
                        <Link to='/'>
                            <img src='/svg/akai-professional.svg' alt='' />
                        </Link>
                        {/* DESKTOP SEARCH BAR */}
                        <NavSearch className='d-none d-md-flex' /> 
                    </Stack>

                    {/* PERFECT CENTER */}
                    <Navbar.Brand className='position-absolute top-50 start-50 translate-middle p-0 m-0'>
                        <Link to='/'>
                            <img src='/svg/brand-logo.svg' alt='' />
                        </Link>
                    </Navbar.Brand>

                    <Stack direction='horizontal' className='align-items-center' gap={4}>
                        <Bag />

                        {/* HAMBURGER */}
                        <Navbar.Toggle onClick={() => setShowNav(true)} className='p-0 border-0'>
                            <img src='/svg/toggler-icon-white.svg' alt='' />
                        </Navbar.Toggle>
                    </Stack>
                </Container>
            </Container>
            
            <Nav />
            <Cart />
        </Navbar>
    )
}
